import styled from 'styled-components';
import { Link } from 'react-router-dom';

const linkTemplate = `
  display: inline-block;
  cursor: pointer;
  :link, :visited {
    color: ${(props) => props.theme.primary.main};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const LinkStyled = styled(Link).attrs({
  className: 'component__link',
})`${linkTemplate}`;

export const AStyled = styled.a.attrs({
  className: 'component__link',
})`${linkTemplate}`;
